import styled from 'styled-components';
import { AppStyledProps } from '../../../types';

// eslint-disable-next-line @typescript-eslint/ban-types
type T = {} & AppStyledProps;
export const Wrapper = styled.div<T>`
  overflow: hidden;
  font-family: 'Roboto';
  color: black;
  width: 100vw;
  height: 100vh;
  margin: 0;
  z-index: 999;
  position: absolute;
  background: white;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  ${({ theme }) =>
    theme.device.mobile &&
    `
    height: calc(var(--vh, 1vh) * 100);
  `}
`;

export const ImageBlock = styled.div<T>`
  background-image: url('/try-again.svg');
  background-size: cover;
  height: 200px;
  width: 300px;
  ${({ theme }) =>
    theme.device.mobile &&
    `
    height: 100px;
    width: 150px;
  `}
`;

export const TextBlockWrap = styled.div<T>`
  max-width: 100%;
  margin: 50px auto 0 auto;
  width: 960px;
  text-align: center;
  ${({ theme }) =>
    theme.device.mobile &&
    `
      margin-top: 20px;
    `}
`;

export const TitleText = styled.div<T>`
  font-size: 34px;
  font-weight: bold;
  padding: 0 50px;
  margin-bottom: 30px;
`;

export const DescriptionText = styled.div<T>`
  display: none;
  font-size: 16px;
  padding: 0 50px;
  margin-bottom: 30px;
`;

export const ButtonWrap = styled.div<T>`
  display: flex;
  justify-content: center;
  margin: 20px 0;
`;

export const RedCornerBtn = styled.button`
  background: var(--color-secondary);
  color: white;
  font-size: 15px;
  height: 40px;
  padding: 0 35px;
  border: 1px solid white;
  margin: 0 10px;

  &:hover {
    color: var(--color-secondary);
    background: white;
    outline: none;
    border: 1px solid;
  }
`;
export const RedBtn = styled.button`
  background: var(--color-secondary);
  color: white;
  font-size: 15px;
  height: 40px;
  padding: 0 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  i {
    margin-left: 13px;
    font-size: 21px;
  }
  margin: 0 10px;

  &:hover {
    color: var(--color-secondary);
    background: white;
    outline: none;
    border: 1px solid;
  }
`;
